import { useEffect } from "react"
import { useFormContext, useWatch } from "react-hook-form"

interface UseValidationTriggersProps {
  productIndex: number
}

interface UseValidationTriggersReturn {
  atypicalSurchargeAmounts: any[]
}

export const useValidationTriggers = ({ productIndex }: UseValidationTriggersProps): UseValidationTriggersReturn => {
  const { trigger } = useFormContext()

  const atypicalSurchargeAmounts = useWatch({
    control: undefined,
    name: `products.${productIndex}.atypicalSurcharges`,
  })

  // Trigger validation for atypical surcharge type fields when amount changes
  useEffect(() => {
    if (atypicalSurchargeAmounts) {
      atypicalSurchargeAmounts.forEach(
        (surcharge: { type?: any; description?: string; amount?: number | null }, surchargeIndex: number) => {
          const amount = surcharge?.amount
          if (amount !== null && amount !== undefined) {
            trigger(`products.${productIndex}.atypicalSurcharges.${surchargeIndex}.type`)
          }
        }
      )
    }
  }, [atypicalSurchargeAmounts, trigger, productIndex])

  return {
    atypicalSurchargeAmounts,
  }
}
